// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1685d66f","455":"fab952d0"}[chunkId] + ".chunk.js";
};